import { render, staticRenderFns } from "./YearStartInput.vue?vue&type=template&id=067236ea&"
import script from "./YearStartInput.vue?vue&type=script&lang=ts&"
export * from "./YearStartInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports